// Module
var code = "<ul class=\"im-msg-list\"> </ul> ";
// Exports
module.exports = code;